<template>
  <div class="PageContent container">
    <transition name="slide">
      <div v-show="visible_overlay" class="OverLay"></div>
    </transition>
    <div class="LeftBlock">
      <div class="BackPanel">
        <a href="/" class="BackLink">
          <div class="BlockShadow">
            <img
              src="./../assets/img/ReDesign/pages/catalog/arrow-back.svg"
              alt=""
            />
          </div>
          <div class="BackText">
            <span>{{ $t("pages.catalog.back") }}</span>
            <span>{{ $t("pages.catalog.go_main") }}</span>
          </div>
        </a>
      </div>
      <transition name="slideBottom">
        <div
          v-show="visible_window_filters"
          class="FiltersBlock"
          :style="styleFiltersBlock"
          ref="filtersBlock"
        >
          <div class="FiltersPanel">
            <h3>{{ $t("pages.catalog.filters.title") }}</h3>
            <button class="FilterClose" @click="toggleFiltersWindow()">
              <img
                src="./../assets/img/ReDesign/pages/catalog/close-icon.svg"
                alt=""
              />
            </button>
          </div>
          <div class="SpaceBetween">
            <div class="Filters" ref="Filters">
              <!--<CustomSelect
                v-model="filters.lvls"
                :options="filters.lvlsDiff"
                label="Уровень сложности"
                type="multiselect"
                typeLabel="big"
                typeSelect="checkboxList"
              />
              <CustomSelect
                v-model="filters.areas"
                :options="filters.areasTraining"
                placeholder="Направления подготовки"
                type="multiselect"
              />-->
              <div class="RangeContainer">
                <span>{{
                  $t("pages.catalog.filters.types.course_duration.comment")
                }}</span>
                <div class="RangeInputs">
                  <DefaultInput
                    v-model="filters.durationFrom"
                    :placeholder="minDuration"
                    type="number"
                    :isValidate="false"
                  />
                  <DefaultInput
                    v-model="filters.durationTo"
                    :placeholder="maxDuration"
                    type="number"
                    :isValidate="false"
                  />
                </div>
              </div>
              <div class="RangeContainer">
                <span>{{
                  $t("pages.catalog.filters.types.price.comment")
                }}</span>
                <div class="RangeInputs">
                  <DefaultInput
                    v-model="filters.priceFrom"
                    :placeholder="minPrice"
                    type="price"
                    :isValidate="false"
                  />
                  <DefaultInput
                    v-model="filters.priceTo"
                    :placeholder="maxPrice"
                    type="price"
                    :isValidate="false"
                  />
                </div>
              </div>
              <CustomSelect
                v-model="filters.formats"
                :options="filters.formatsClass"
                :label="$t('pages.catalog.filters.types.train_format.comment')"
                type="multiselect"
                typeLabel="big"
                typeSelect="checkboxList"
              />
              <CustomSelect
                v-model="filters.events"
                :options="filters.areasEvent"
                :placeholder="
                  $t('pages.catalog.filters.types.areas_event.comment')
                "
                type="multiselect"
              />
              <CustomSelect
                v-model="filters.langs"
                :options="filters.langsList"
                :label="$t('pages.catalog.filters.types.lang.comment')"
                type="multiselect"
                typeLabel="big"
                typeSelect="checkboxList"
              />
            </div>
            <div class="FilterButtons">
              <button
                style="height: 48px; font-size: 16px"
                class="btn-n-white"
                @click="addedFilters()"
              >
                {{ applyFiltersText }}
              </button>
              <button
                style="height: 48px; font-size: 16px"
                class="btn-n-white-no-border"
                @click="resetFilters()"
              >
                {{ $t("pages.catalog.filters.buttons.reset") }}
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="RightBlock">
      <div class="TitlePanel">
        <h1>{{ $t("pages.catalog.title") }}</h1>
        <button class="FilterOpen" @click="toggleFiltersWindow()">
          <img src="./../assets/img/ReDesign/pages/catalog/filters-icon.svg" />
        </button>
      </div>
      <div class="SearchBar" ref="SearchBar">
        <DefaultSearchInput
          class="SearchInput"
          v-model="filters.searchFilter"
          :placeholder="$t('pages.catalog.inputs.search.placeholder')"
        />
        <div class="SortSelect" ref="SortBar">
          <CustomSelect v-model="sort.selectValue" :options="sort.options" />
        </div>
      </div>
      <div v-if="isLoading" class="loader-container">
        <div class="spinning-loader">
          <div class="spinner-ring ring-1"></div>
          <div class="spinner-ring ring-2"></div>
          <div class="spinner-ring ring-3"></div>
          <div class="center-dot"></div>
        </div>
        <div class="loading-text">{{ $t("pages.catalog.loader.title") }}</div>
      </div>
      <div v-else>
        <div v-if="filteredCourses.length > 0" class="PaginationContainer">
          <div class="CoursesList">
            <div
              v-for="course in filteredCourses"
              :key="course.id"
              class="Questionnaires"
            >
              <div v-if="course.forWhom" class="LvlSkill">
                <p>{{ course.forWhom }}</p>
              </div>
              <div class="MainInfo">
                <div class="TitleQuest">
                  <router-link
                    class="title-h2"
                    :to="{
                      path: '/catalog/course',
                      query: {
                        id: course.id,
                      },
                    }"
                  >
                    {{ course.name }}
                  </router-link>
                  <p class="FontSize18px">
                    {{ course.n_project.name }}
                  </p>
                  <a
                    :href="
                      course.n_project?.yandex_map_link
                        ? course.n_project?.yandex_map_link
                        : null
                    "
                    @click="
                      !course.n_project?.yandex_map_link
                        ? copyText(addressFormat(course.n_project?.address))
                        : null
                    "
                    class="CompanyAddr"
                    target="_blank"
                  >
                    {{ addressFormat(course.n_project?.address) }}
                  </a>
                  <div class="ShortInfo">
                    <p v-if="course.courseDuration">
                      {{ monthDeclension(course.courseDuration) }}
                    </p>
                    <p v-if="course.trainFormat">
                      {{ $t(course.trainFormat) }}
                    </p>
                    <p v-if="course.lang">{{ langName(course.lang) }}</p>
                  </div>
                  <div v-if="course.dateStart" class="ShortInfo">
                    <p>
                      {{ $t("pages.catalog.questionnaires.date_start") }}
                      {{ dateFormated(course.dateStart) }}
                    </p>
                  </div>
                </div>
                <div class="Price">
                  <h2>
                    {{ formatNumber(course.price) }}
                    {{ $t("pages.catalog.questionnaires.sum") }}
                  </h2>
                  <div v-if="course.trialSession" class="CheckMarkText">
                    <img
                      src="./../assets/img/ReDesign/pages/catalog/check-mark.svg"
                    />
                    <p>
                      {{ $t("pages.catalog.questionnaires.trial_session") }}
                    </p>
                  </div>
                  <div v-if="course.homework" class="CheckMarkText">
                    <img
                      src="./../assets/img/ReDesign/pages/catalog/check-mark.svg"
                    />
                    <p>{{ $t("pages.catalog.questionnaires.homework") }}</p>
                  </div>
                  <div v-if="course.finalExam" class="CheckMarkText">
                    <img
                      src="./../assets/img/ReDesign/pages/catalog/check-mark.svg"
                    />
                    <p>{{ $t("pages.catalog.questionnaires.final_exam") }}</p>
                  </div>
                </div>
              </div>
              <div class="QuestButtonsContainer">
                <button
                  class="btn-n-yellow QuestButton"
                  @click.native="
                    () => {
                      requestModalShow = 1;
                      rmCourse = course;
                      disableScroll();
                    }
                  "
                >
                  {{ $t("pages.catalog.questionnaires.buttons.request") }}
                </button>
                <router-link
                  class="btn-n-white btn-router-link QuestButton"
                  :to="{
                    path: '/catalog/course',
                    query: {
                      id: course.id,
                    },
                  }"
                >
                  {{ $t("pages.catalog.questionnaires.buttons.course_program") }}
                </router-link>
              </div>
            </div>
          </div>
          <Pagination
            class="LastElement"
            :key="`Pagination-${paginationKey}`"
            :dataCounter="filteredCoursesCount"
            :max_items="maxItems"
            :max_pages_indexes="5"
            :startPage="currentPage"
            @update:page="handlePageChange"
          />
        </div>
        <div v-else class="Questionnaires">
          <div class="TitleQuest">
            <h2>
              {{ $t("pages.catalog.questionnaires.courses_not_found.title") }}
            </h2>
          </div>
          <p>
            {{ $t("pages.catalog.questionnaires.courses_not_found.comment_1") }}
          </p>
          <p>
            {{ $t("pages.catalog.questionnaires.courses_not_found.comment_2") }}
          </p>
        </div>
      </div>
    </div>
    <DefaultModal
      v-if="requestModalShow === 1"
      class="DefaultModal"
      :rmtitle="$t(requestModal[0].title)"
      :rmdesc="$t(requestModal[0].desc)"
      :handleModalClose="handleCloseModal"
    >
      <template v-slot:FormBody>
        <p>{{ $t("components.default_modal[0].select") }}</p>
        <h4>{{ rmCourse ? rmCourse.n_project.name : "" }}</h4>
        <DefaultInput
          v-model="rMfio"
          @update:modelStatus="rMfioValidate = $event"
          :placeholder="$t('components.default_modal[0].name_surname')"
          :isNull="false"
          type="fio"
        />
        <DefaultInput
          v-model="rMphone"
          @update:modelPhoneFormat="phoneFormat = $event"
          @update:modelStatus="rMphoneValidate = $event"
          :label="$t('components.default_modal[0].phone')"
          type="phone"
          :isNull="false"
        />
        <DefaultTextarea
          v-model="rmComment"
          @update:modelStatus="rmCommentValidate = $event"
          :placeholder="$t('components.default_modal[0].comment')"
        />
      </template>
      <template v-slot:ButtonsSection>
        <div class="data-policy">
          <CustomSelect
            v-model="dataPolicy"
            :options="dataPolicyOpt"
            style="width: fit-content"
            type="multiselect"
            typeSelect="checkboxList"
          />
          <span class="text">
            {{ $t("components.default_modal[2].condition_agreement_1") }}
            <a class="link" :href="$t('links.data_policy')" download
              >{{ $t("components.default_modal[2].condition_agreement_2") }}</a
            >
          </span>
        </div>

        <span
          style="height: 48px; font-size: 16px"
          class="btn-router-link"
          :class="{
            'btn-n-yellow': validateRequestSucces,
            'btn-n-yellow-disabled': !validateRequestSucces,
          }"
          @click.native="sendRequest"
        >
          {{ $t("components.default_modal[0].button") }}
        </span>
      </template>
    </DefaultModal>
    <DefaultModal
      v-show="requestModalShow === 2"
      :rmtitle="$t(requestModal[1].title)"
      :rmdesc="$t(requestModal[1].desc)"
      :handleModalClose="handleCloseModal"
    >
      <template v-slot:ButtonsSection>
        <span
          style="height: 48px; font-size: 16px"
          class="btn-n-yellow btn-router-link"
          @click.native="handleCloseModal"
        >
          {{ $t("components.default_modal[1].button") }}
        </span>
      </template>
    </DefaultModal>
  </div>
</template>

<script>
import DefaultModal from "@/components/DefaultModal";
import Pagination from "@/components/OctaUI/Pagination.vue";
import DefaultInput from "@/components/OctaUI/Inputs/DefaultInput.vue";
import DefaultTextarea from "@/components/OctaUI/Inputs/DefaultTextarea.vue";
import CustomSelect from "@/components/OctaUI/Selects/CustomSelect.vue";
import DefaultSearchInput from "@/components/OctaUI/Inputs/DefaultSearchInput.vue";

import { getCoursesList } from "@/api/n_project.js";
import { RequestCreate } from "@/api/request.js";
import { ElNotification } from "element-plus";

import "@/assets/css/Repainting/Buttons.css";

export default {
  components: {
    DefaultModal,
    Pagination,
    DefaultInput,
    DefaultTextarea,
    CustomSelect,
    DefaultSearchInput,
  },
  data() {
    return {
      // Данные для адаптива
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,

      // Данные для скролинга фильтров
      filtersScroll: {
        type: null,
        offsetTop: 0,
        lastY: window.pageYOffset,
      },

      // Данные для фильтра
      filters: {
        // Активный фильтры
        active: [],

        // Фильтр поиска
        searchFilter: "",

        // Фильтры панели
        //lvls: [],
        //areas: [],
        durationFrom: null,
        durationTo: null,
        priceFrom: null,
        priceTo: null,
        formats: [],
        events: [],
        langs: [],
        /*lvlsDiff: [
          { value: "Для начинающих", name: "Для начинающих" },
          { value: "Для продвинутых", name: "Для продвинутых" },
        ],
        areasTraining: [
        ],*/
        formatsClass: [
          {
            value: "tables.jobs.train_format.online",
            name: "tables.jobs.train_format.online",
          },
          {
            value: "tables.jobs.train_format.offline",
            name: "tables.jobs.train_format.offline",
          },
          {
            value: "tables.jobs.train_format.hybrid",
            name: "tables.jobs.train_format.hybrid",
          },
        ],
        areasEvent: [
          // Автозаполнение при загрузке курсов
        ],
        langsList: [
          { value: 3, name: "Oʻzbekcha" },
          { value: 1, name: "Русский" },
        ],
      },

      // Данные для сортировки
      sort: {
        selectValue: "price-inc",
        options: [
          {
            value: "price-inc",
            name: "pages.catalog.filters.types.sort.options.price-inc",
          },
          {
            value: "price-dec",
            name: "pages.catalog.filters.types.sort.options.price-dec",
          },
          {
            value: "courseDuration-inc",
            name: "pages.catalog.filters.types.sort.options.courseDuration-inc",
          },
          {
            value: "courseDuration-dec",
            name: "pages.catalog.filters.types.sort.options.courseDuration-dec",
          },
        ],
      },

      // Сообщения
      msg: {
        title: {
          copySuccess: this.$t("components.el_notification[0].message_copy_addr"),
          serverError: this.$t("components.el_notification[1].message"),
          copyError: this.$t("components.el_notification[1].message_copy_error"),
        },
        form: {
          success: {
            title: this.$t("components.el_notification[0].title"),
            type: "success",
            position: "bottom-right",
            customClass: "ELDefaultNotification",
          },
          error: {
            title: this.$t("components.el_notification[1].title"),
            type: "error",
            position: "bottom-right",
            customClass: "ELDefaultNotification",
          },
        },
      },

      scrollPosition: 0,
      visible_overlay: false,
      visible_window_filters: false,
      requestModalShow: null,
      paginationKey: Date.now(),
      maxItems: 8,
      currentPage: 1,
      isLoading: true,
      langList: [
        { id: 1, lang: "Русский" },
        { id: 2, lang: "English" },
        { id: 3, lang: "Oʻzbekcha" },
      ],
      requestModal: [
        {
          title: "components.default_modal[0].title",
          desc: "components.default_modal[0].desc",
        },
        {
          title: "components.default_modal[1].title",
          desc: "components.default_modal[1].desc",
        },
      ],
      rMfio: "",
      rMfioValidate: false,
      phoneFormat: null,
      rMphone: "",
      rMphoneValidate: false,
      rmComment: "",
      rmCommentValidate: false,
      rmCourse: null,
      dataPolicy: [],
      dataPolicyOpt: [{
        value: "dataPolicy",
        name: "",
      }],

      filteredCoursesCount: 0,
      courses: [],
    };
  },
  mounted() {
    this.handleResize();
    this.getFullCourses();
    window.addEventListener("scroll", this.scrollFilters);
    window.addEventListener("resize", this.handleResize);
  },
  computed: {
    // Стили для FiltersBlock при скролинге
    styleFiltersBlock() {
      // Если версия не мобильная(Ширина больше 880px)
      if (this.windowWidth > 880) {
        let top = null;
        if (!this.filtersScroll.type) top = this.filtersScroll.offsetTop;
        else if (this.filtersScroll.type === "up") top = "20px";

        return {
          'position': this.filtersScroll.type ? "sticky" : null,
          'top': top,
          'bottom': this.filtersScroll.type === "down" ? "20px" : null,
          'margin-top': this.filtersScroll.type === "down" ? "auto" : null,
        };
      } else {
        return null;
      }
    },

    applyFiltersText() {
      let applyText = this.$t("pages.catalog.filters.buttons.apply[1]");
      let countFilters = 0;
      let filtersText = [
        this.$t("pages.catalog.filters.buttons.apply[2]"),
        this.$t("pages.catalog.filters.buttons.apply[3]"),
        this.$t("pages.catalog.filters.buttons.apply[4]"),
      ];

      // Считаем количество применнёных фильтров
      this.filters.durationFrom ? countFilters++ : "";
      this.filters.durationTo ? countFilters++ : "";
      this.filters.priceFrom ? countFilters++ : "";
      this.filters.priceTo ? countFilters++ : "";
      countFilters += this.filters.formats.length;
      countFilters += this.filters.events.length;
      countFilters += this.filters.langs.length;

      /* На основе количества фильтров выбираем текст */
      // Если фильтров нет, возвращаем текст "Применить фильтры"
      if (countFilters === 0)
        return this.$t("pages.catalog.filters.buttons.apply[0]");
      // Если количество фильтров по модуль 10 равно 0 или (больше или равно 5), либо входит в 11-14
      // То возвращаем "Применить N фильтров"
      if (
        countFilters % 10 >= 5 ||
        countFilters % 10 === 0 ||
        [11, 12, 13, 14].find((item) => item === countFilters)
      )
        return applyText + " " + countFilters + " " + filtersText[2];
      // Иначе если количество фильтров по модуль 10 больше или равно 2
      // То возвращаем "Применить N фильтра"
      if (countFilters % 10 >= 2)
        return applyText + " " + countFilters + " " + filtersText[1];

      // Иначе возвращаем "Применить N фильтр"
      return applyText + " " + countFilters + " " + filtersText[0];
    },

    validateRequestSucces() {
      return (
        this.rMfioValidate && this.rMphoneValidate && this.rmCommentValidate && this.dataPolicy.length > 0
      );
    },

    filteredCourses() {
      let courses = [...this.courses];
      const [key, sort_type] = this.sort.selectValue.split("-");

      // Сортировка
      courses.sort((param1, param2) => {
        let value1 = param1[key];
        let value2 = param2[key];

        // Строчки
        if (typeof value1 === "string") {
          value1 = value1.toLowerCase();
          value2 = value2.toLowerCase();
          return sort_type === "inc"
            ? value1.localeCompare(value2)
            : value2.localeCompare(value1);
        }

        // Числа
        return sort_type === "inc" ? value1 - value2 : value2 - value1;
      });

      // Фильтрация
      courses = courses.filter((course) => {
        // Поиск по названию
        if (
          !course.name
            .toLowerCase()
            .includes(this.filters.searchFilter.toLowerCase())
        ) {
          return false;
        }

        // Фильтр по продолжительности
        if (
          this.filters.active.durationFrom &&
          course.courseDuration &&
          course.courseDuration < this.filters.active.durationFrom
        ) {
          return false;
        }
        if (
          this.filters.active.durationTo &&
          course.courseDuration &&
          course.courseDuration > this.filters.active.durationTo
        ) {
          return false;
        }

        // Фильтр по цене
        if (
          this.filters.active.priceFrom &&
          course.price &&
          course.price < this.filters.active.priceFrom
        ) {
          return false;
        }
        if (
          this.filters.active.priceTo &&
          course.price &&
          course.price > this.filters.active.priceTo
        ) {
          return false;
        }

        // Фильтр по формату занятий
        if (
          this.filters.active.formats &&
          course.trainFormat &&
          !this.filters.active.formats.find(
            (item) => item === course.trainFormat
          )
        ) {
          return false;
        }

        // Фильтр по районам проведения
        if (this.filters.active.events && course.n_project?.address) {
          const address = course.n_project.address.split("{%;%}");

          const findAddres = this.filters.active.events.find(
            (item) => item === address[0]
          );

          if (!findAddres) return false;
        }

        // Фильтр по языкам
        if (
          this.filters.active.langs &&
          course.lang &&
          !this.filters.active.langs.find((item) => item === course.lang)
        ) {
          return false;
        }

        return true;
      });

      // Перенаправление на 1 страницу, если количество курсов меньше текущей страницы
      if ((this.currentPage - 1) * this.maxItems >= courses.length) {
        this.paginationKey++;
        this.handlePageChange(1);
      }

      // Записываем фактическое количество курсов после фильтрации до slice
      this.filteredCoursesCount = courses.length;

      // Возвращаем курсы для данной страницы(currentPage)
      return courses.slice(
        this.maxItems * (this.currentPage - 1),
        this.maxItems * (this.currentPage - 1) + this.maxItems
      );
    },

    minDuration() {
      let text = this.$t("pages.catalog.filters.types.course_duration.from");

      // Если есть хотя б один курс, то ищем минимальную продолжительность
      if (this.courses && this.courses.length > 0) {
        text +=
          " " +
          Math.min(...this.courses.map((course) => course.courseDuration));
      }

      return text;
    },

    maxDuration() {
      let text = this.$t("pages.catalog.filters.types.course_duration.to");

      // Если есть хотя б один курс, то ищем максимальную продолжительность
      if (this.courses && this.courses.length > 0) {
        text +=
          " " +
          Math.max(...this.courses.map((course) => course.courseDuration));
      }

      return text;
    },

    minPrice() {
      let text = this.$t("pages.catalog.filters.types.price.from");

      // Если есть хотя б один курс, то ищем минимальную стоимость
      if (this.courses && this.courses.length > 0) {
        let minPrice = Math.min(...this.courses.map((course) => course.price));

        text += " " + this.formatedPrice(minPrice);
      }

      return text;
    },

    maxPrice() {
      let text = this.$t("pages.catalog.filters.types.price.to");

      // Если есть хотя б один курс, то ищем максимальную стоимость
      if (this.courses && this.courses.length > 0) {
        let maxPrice = Math.max(...this.courses.map((course) => course.price));

        text += " " + this.formatedPrice(maxPrice);
      }

      return text;
    },
  },
  methods: {
    async getFullCourses() {
      try {
        let request = [];
        let countRequest = 0;
        let dataLastRequest = [];

        // Загружаем список курсов пакетами по maxItems
        while (countRequest === 0 || dataLastRequest.length > 0) {
          dataLastRequest = (
            await getCoursesList(this.maxItems, countRequest * this.maxItems)
          ).data;
          this.courses.push(...dataLastRequest);

          // Если произошла загрузка первого пакета курсов
          if (countRequest === 0) {
            this.isLoading = false; // Убираем лоадер
            this.filtersScroll.type = "up"; // Обновляем скрол фильтраций
          }

          countRequest++;
        }

        this.fillAreasEvent();
      } catch (e) {
        console.log(e);
      }
    },

    scrollFilters() {
      // Получаем информацию блоке фильтров
      const filtersBlock = this.$refs.filtersBlock;

      if (filtersBlock) {
        // Вытаскиваем информацию о положении
        const rect = filtersBlock.getBoundingClientRect();

        // В случае если высота окна больше высоты фильтров, то всегда up(sticky по верхнему краю)
        if (rect.top >= 0 && rect.bottom <= this.windowHeight) {
          this.filtersScroll.type = "up";
          return;
        }

        /*
          Если скрол шёл вверх после начала блока и мы пошли вниз, 
          то запоминаем позицию блока и делаем его relative
        */
        if (
          this.filtersScroll.type === "up" &&
          window.pageYOffset > this.filtersScroll.lastY
        ) {
          this.filtersScroll.offsetTop = `${filtersBlock.offsetTop - 72}px`;
          this.filtersScroll.type = null;
        }

        /*
          Если скрол шёл вниз после конца блока и мы пошли вверх,
          то запоминаем позицию блока и делаем его relative
        */
        if (
          this.filtersScroll.type === "down" &&
          window.pageYOffset < this.filtersScroll.lastY
        ) {
          this.filtersScroll.offsetTop = `${filtersBlock.offsetTop - 72}px`;
          this.filtersScroll.type = null;
        }

        // Если дошли до начала блока фильтров с top = 20px(Скроля вверх)
        if (rect.top >= 20 && window.pageYOffset < this.filtersScroll.lastY) {
          this.filtersScroll.type = "up";
        }

        // Если дошли до конца блока фильтров с bottom = 20px(Скроля вниз)
        if (
          rect.bottom <= this.windowHeight - 20 &&
          window.pageYOffset > this.filtersScroll.lastY
        ) {
          this.filtersScroll.type = "down";
        }
      }

      // Запоминаем прошлую позицию скрола, чтобы определять направление
      this.filtersScroll.lastY = window.pageYOffset;
    },

    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        ElNotification({
            ...this.msg.form.success,
            message: this.msg.title.copySuccess,
          });
      } catch (err) {
        console.log(err);
        ElNotification({
          ...this.msg.form.error,
          message: this.msg.title.copyError,
        });
      }
    },

    // Формартирую адрес в вид "[0], [1], [2], [3], [4], [5]"
    addressFormat(address) {
      if (!address) return "";

      const addressSplit = address.split("{%;%}");
      let result = "";

      for (const element of addressSplit) {
        if (!result) result += element;
        else if (element) result += ", " + element;
      }

      return result;
    },

    dateFormated(date) {
      if (!date) return '';
      
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      
      return `${day}.${month}.${year}`;
    },

    // Склонение месяцев
    monthDeclension(months) {
      let monthsText = [
        this.$t("pages.catalog.questionnaires.months[0]"),
        this.$t("pages.catalog.questionnaires.months[1]"),
        this.$t("pages.catalog.questionnaires.months[2]"),
      ];

      // На основе количества месяцев выбираем склонение
      // Если окончание 0, 5-9 или число входит в 11-14 - "месяцев"
      if (
        months % 10 >= 5 ||
        months % 10 === 0 ||
        [11, 12, 13, 14].find((item) => item === months)
      )
        return months + " " + monthsText[2];
      // Если окончание 2-4 - "месяца"
      if (months % 10 >= 2) return months + " " + monthsText[1];

      // Иначе если окончание 1 - "месяц"
      return months + " " + monthsText[0];
    },

    // Получаем районы проведения вытаскивая из адреса курсов районы
    fillAreasEvent() {
      const areasEvent = [];

      for (const course of this.courses) {
        if (course.n_project?.address) {
          const address = course.n_project.address.split("{%;%}");

          areasEvent.push({
            value: address[0],
            name: address[0],
          });
        }
      }

      this.filters.areasEvent = [
        ...new Map(areasEvent.map((item) => [item.name, item])).values(),
      ];
    },

    // Форматируем прайс, добавляя пробелы(1000 -> 1 000)
    formatedPrice(price) {
      return new Intl.NumberFormat("ru-RU").format(price);
    },

    // Из id языка получаем его название
    langName(id) {
      return this.langList.find((lang) => lang.id === id).lang;
    },
    handlePageChange(page) {
      this.currentPage = page;
    },
    handleCloseModal() {
      this.requestModalShow = null;
      this.enableScroll();
      this.rMfio = "";
      this.rMphone = "";
      this.rmComment = "";
      this.dataPolicy = [];
    },
    async sendRequest() {
      let full_number = this.phoneFormat + this.rMphone.replace(/\D/g, "");

      try {
        let reqResponse = await RequestCreate({
          surname_name: this.rMfio,
          phone: full_number.replaceAll(" ", ""),
          email: "",
          additional: this.rmComment,
          course_id: this.rmCourse.id,
          education_id: this.rmCourse.n_project.company_id,
          type_code: "ec_catalog_request",
          data_policy: this.dataPolicy.length > 0 ? true : false
        });

        if (reqResponse.status != 200) {
          throw new Error("Ошибка");
        }

        this.requestModalShow = 2;
      } catch (e) {
        ElNotification({
          ...this.msg.form.error,
          message: this.msg.title.serverError,
        });
      }

      this.requestModalShow = 2;
    },
    handleResize() {
      const SortBar = this.$refs.SortBar;
      const Filters = this.$refs.Filters;
      const SearchBar = this.$refs.SearchBar;

      if (!SortBar || !Filters || !SearchBar) {
        return;
      }

      this.windowWidth = window.innerWidth;

      if (window.innerWidth <= 1160) {
        if (SortBar?.parentNode !== Filters && typeof Filters.insertBefore === 'function') {
          Filters.insertBefore(SortBar, Filters.firstChild);
        }
      } else {
        if (SortBar?.parentNode !== SearchBar && typeof SearchBar.appendChild === 'function') {
          SearchBar.appendChild(SortBar);
        }
      }
      if (window.innerWidth > 880) {
        this.visible_window_filters = true;
        this.visible_overlay = false;
      } else {
        this.visible_window_filters = false;
        this.visible_overlay = false;
      }
    },
    addedFilters() {
      this.filters.active = {};

      this.filters.durationFrom
        ? (this.filters.active.durationFrom = this.filters.durationFrom)
        : "";
      this.filters.durationTo
        ? (this.filters.active.durationTo = this.filters.durationTo)
        : "";
      this.filters.priceFrom
        ? (this.filters.active.priceFrom = Number(this.filters.priceFrom.replace(/\s/g, ""))) // Убираем пробелы и переводим в число
        : "";
      this.filters.priceTo
        ? (this.filters.active.priceTo = Number(this.filters.priceTo.replace(/\s/g, "")))// Убираем пробелы и переводим в число
        : "";
      this.filters.formats.length > 0
        ? (this.filters.active.formats = [...this.filters.formats])
        : "";
      this.filters.events.length > 0
        ? (this.filters.active.events = [...this.filters.events])
        : "";
      this.filters.langs.length > 0
        ? (this.filters.active.langs = [...this.filters.langs])
        : "";
    },
    resetFilters() {
      this.filters.active = {};

      this.filters.durationFrom = null;
      this.filters.durationTo = null;
      this.filters.priceFrom = null;
      this.filters.priceTo = null;
      this.filters.formats = [];
      this.filters.events = [];
      this.filters.langs = [];
    },
    // Открываем/закрываем вкладку фильтров
    toggleFiltersWindow() {
      this.visible_window_filters = !this.visible_window_filters;
      this.visible_overlay = !this.visible_overlay;
    },
    disableScroll() {
      // Запоминаем позицию скролла
      this.scrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Рассчитываем ширину скроллбара
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      // Блокируем скролл
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = "100%";
      document.body.style.height = "100%";

      // Компенсируем ширину скроллбара
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      // Для iOS Safari
      document.body.style.overscrollBehavior = "none";
    },
    enableScroll() {
      // Восстанавливаем скролл
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.height = "";
      document.body.style.paddingRight = "";

      // Возвращаем позицию скролла
      window.scrollTo(0, this.scrollPosition);

      // Для iOS
      document.body.style.overscrollBehavior = "";
    },
    formatNumber(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>

<style scoped>
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
.OverLay {
  display: flex;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  transition: 0.6s;
  z-index: 1999;
}
.LastElement {
  padding-top: 80px;
}
.SpaceBetween {
  position: relative;
  display: flex;

  width: 100%;
  height: 100%;

  flex-direction: column;
  justify-content: space-between;
}
.RangeContainer {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  gap: 8px;
}
.RangeContainer span {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;

  color: #1a1a1a;
}
.RangeInputs {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  align-items: flex-end;
  gap: 8px;
}
.PageContent .DefaultModal h4 {
  font-weight: 500;
  font-size: 16px;

  position: relative;
  display: flex;
  max-width: 100%;
  flex-shrink: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.PageContent .DefaultModal p {
  font-size: 14px;
}
.PageContent .DefaultModal .InputWithPrefix {
  position: relative;
  display: flex;
  align-items: center;
}
.PageContent .DefaultModal .PhoneFormat {
  position: absolute;
  left: 16px;
  z-index: 2;
  font-size: 16px;
  font-weight: 500;
  color: #666666;
  pointer-events: none;
}
.PageContent .DefaultModal .ErrorMessage {
  font-family: "Open Sans";
  left: 16px;
  z-index: 2;
  font-size: 14px;
  font-weight: 500;
  color: #dc3545;
  pointer-events: none;
}
.PageContent .IWFBErrorBorder {
  border: 0.8px solid #dc3545 !important;
  outline: none;
}
.ModalButton {
  width: 100% !important;
}
.ModalButton.Disabled {
  background: #e0e0e0 !important;
  border: none;
  color: #898989;
  pointer-events: none;
  user-select: none;
  cursor: not-allowed;
}
.PageContent {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 25px;

  font-family: "Involve";
}
.ModalCompanyInfo {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  gap: 4px;
}
.PageContent input {
  font-family: "Involve";
  font-weight: 500;
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 40px;
  gap: 10px;
  width: 560px;
  height: 52px;
  border: 0.8px solid #e0e0e0;
  border-radius: 8px;
  background-image: url("./../assets/img/ReDesign/pages/catalog/search-icon.svg");
  background-repeat: no-repeat;
  background-position: 16px center;
}
.PageContent input:focus {
  border: 0.8px solid #f9d773 !important;
  outline: none;
}
.PageContent .Search.Selected {
  font-weight: 500;
  font-size: 16px;
  color: #1a1a1a;
  border: 1px solid #e0e0e0;
}
.PageContent .DefaultModal input {
  background: none;
  width: 100%;
  padding-left: 16px;
  font-size: 16px;
  color: #666666;
}
.PageContent input:hover {
  border: 0.8px solid #f9d773 !important;
  transition: 0.3s !important;
}
.FiltersPanel {
  display: none;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
}
.FiltersPanel h3 {
  font-weight: 500;
  font-size: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #1a1a1a;
}
.PageContent .FiltersPanel button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  border-color: transparent;
  background: #ffffff;
  cursor: pointer;
}
.PageContent .FiltersPanel button:hover {
  transition: 0.3s;
  background: #e8e8e8 !important;
}
.PageContent .FiltersPanel button:active {
  transition: 0.3s;
  background: #c4c4c4 !important;
}
.FilterOpen {
  display: none !important;
}
.PageContent p {
  font-family: "Involve";
  font-weight: 500;
  font-size: 14px;
  color: #666666;
  position: relative;
  display: inline;
  width: fit-content;
  height: fit-content;
  max-width: 100%;
}
.container {
  width: 100%;
  max-width: 1168px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
}
.LeftBlock {
  position: relative;
  display: flex;

  width: 264px;
  height: auto;

  flex-direction: column;
}
.FiltersBlock {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;
}
.BackPanel {
  position: relative;
  display: flex;

  justify-content: flex-end;
  align-items: center;
  height: 42px;
  margin-bottom: 30px;
}
.BackLink {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  gap: 16px;
  text-decoration: none;
}
.BlockShadow {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;
  width: 40px;
  height: 40px;
  background: #ffffff;
  box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.1),
    0px 4px 4px -4px rgba(12, 12, 13, 0.05);
  border-radius: 8px;
  transition: 0.3s;
}
.BackLink:hover .BlockShadow {
  /* margin-right: 20px; */
  transition: 0.3s;
  background: #f8f8f8;
}
.BackText {
  display: flex;
  flex-direction: column;
  font-weight: 500;
  font-size: 14px;
  color: #666666;
  margin-right: 3px;
  transition: 0.3s;
}
.DownloadLink {
  display: inline;
  position: relative;

  flex-direction: column;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  margin-right: 3px;
  transition: 0.3s;
  text-decoration: underline;

  white-space: normal; 
  word-wrap: break-word;
}
.BackLink:hover .BackText {
  /* font-size: 17px; */
  transition: 0.3s;
}
.Filters {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}
.FilterButtons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.FilterResetButton {
  background: #ffffff !important;
}
.FilterResetButton:hover {
  background: rgba(249, 215, 115, 0.1) !important;
  border: none;
  border-color: transparent;
}
.RightBlock {
  display: flex;
  flex-direction: column;
  width: 840px;
}
.TitlePanel {
  display: flex;
  align-items: center;
  height: 42px;
  margin-bottom: 30px;
}
.TitlePanel h1 {
  font-weight: 600;
  font-size: 32px;
}
.SearchBar {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 16px;
}
.SearchInput {
  width: 560px;
}
.SortSelect {
  width: 264px;
}
.Questionnaires {
  display: flex;
  flex-direction: column;
  padding: 24px 24px 24px 24px;
  gap: 24px;
  margin-top: 16px;
  background: #ffffff;
  box-shadow: 0px 0px 16px 6px rgba(224, 224, 224, 0.2);
  border-radius: 16px;
}
.QuestButtonsContainer {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  gap: 8px;
}
.QuestButton {
  position: relative;
  display: flex;

  width: fit-content; 
  height: 48px;

  padding: 12px 20px; 
  font-size: 16px; 
}
.LvlSkill > p,
.TitleQuest > h2,
.TitleQuest > .FontSize18px,
.TitleQuest > .CompanyAddr {
  flex-shrink: 1;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-word;
}
.TitleQuest > .title-h2 {
  display: flex;
  position: relative;

  width: fit-content;
  height: fit-content;

  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;
  color: #232323;

  text-decoration: none;

  flex-shrink: 1;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-word;
}
.TitleQuest > .title-h2:hover {
  color: #232323;
  opacity: 0.5;
}
.LvlSkill {
  position: relative;
  flex-direction: column;
  height: fit-content;
  background: #f8f8f8;
  justify-content: center;
  align-items: center;
  padding: 4px 12px;
  width: fit-content;
  border-radius: 4px;
}
.MainInfo {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
}
.TitleQuest {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 70%;
}
.TitleQuest h2 {
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;
  color: #232323;
}
.TitleQuest a {
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  margin-top: 8px;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  color: #666666;
  transition: all 0.3s ease;
}
.TitleQuest a:hover {
  color: #f9d773;
}
.TitleQuest a:active {
  color: #1a1a1a;
}
.Price {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.Price h2 {
  position: relative;
  word-break: break-word;
  display: inline;
  width: fit-content;
  height: fit-content;
  margin-left: auto;
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: 0%;
  color: #fd6161;
}
.CheckMarkText {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 2px;
  position: relative;
  width: fit-content;
  height: fit-content;
  margin-left: auto;
}
.CheckMarkText p {
  font-size: 12px;
}
.CheckMarkText > img {
  position: relative;
  display: block;
  width: 8.5px;
  height: 16px;
}
.ShortInfo {
  display: flex;
  word-break: break-word;
  flex-direction: row;
  gap: 16px;
  margin-top: 8px;
}
.ShortInfo p {
  display: inline;
}
.SubmitApp {
  width: 175px !important;
}
.FontSize18px {
  font-size: 18px !important;
}
@keyframes slideOpen {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideClose {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.slide-enter-active {
  animation: slideOpen 0.8s ease-out;
}
.slide-leave-active {
  animation: slideClose 0.8s ease-out;
}
.loader-container {
  text-align: center;
  margin-top: 80px;
}
.spinning-loader {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
}
.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}
.ring-1 {
  border: 3px solid transparent;
  border-top: 3px solid #f9d773e5;
  border-right: 3px solid #f9d773e5;
}
.ring-2 {
  border: 3px solid transparent;
  border-top: 3px solid #f9d77333;
  border-right: 3px solid #f9d77333;
  width: 70%;
  height: 70%;
  top: 15%;
  left: 15%;
  animation-duration: 1.5s;
  animation-direction: reverse;
}
.ring-3 {
  border: 3px solid transparent;
  border-top: 3px solid #f9d7731a;
  border-right: 3px solid #f9d7731a;
  width: 50%;
  height: 50%;
  top: 25%;
  left: 25%;
  animation-duration: 1s;
}
.center-dot {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #f9d773e5;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: pulse-center 2s infinite ease-in-out;
}
.loading-text {
  color: #000000;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 2px;
  animation: pulse 2s infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes pulse {
  0%,
  100% {
    opacity: 0.7;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
}
@keyframes pulse-center {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    box-shadow: 0 0 10px #f9d773e5;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.2);
    box-shadow: 0 0 20px #f9d773e5, 0 0 30px #f9d77333;
  }
}

.data-policy {
  display: flex;
  position: relative;

  width: fit-content;
  height: fit-content;

  flex-direction: row;
  gap: 8px;
  align-items: center;
}
.data-policy > .text {
  display: inline-block;
  position: relative;

  width: fit-content;
  height: fit-content;

  font-family: "Involve";
  font-weight: 500;
  font-size: 12px;

  color: #666666;
}
.data-policy > .text > .link {
  display: inline;
  position: relative;

  width: fit-content;
  height: fit-content;

  flex-direction: column;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  margin-right: 3px;
  transition: 0.3s;
  text-decoration: underline;

  white-space: normal; 
  word-wrap: break-word;
}
</style>

<style scoped>
@media (max-width: 1160px) {
  .PageContent input {
    width: 100%;
  }
  .MainInfo {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px;
  }
  .SearchInput {
    width: 100%;
  }
  .SortSelect {
    width: 100%;
  }
  .TitleQuest {
    width: 100%;
  }
  .Price h2 {
    margin-left: 0;
  }
  .CheckMarkText {
    justify-content: flex-start;
    margin-left: 0;
  }
}
@media (max-width: 880px) {
  .PageContent {
    flex-direction: column;
    justify-content: center;
  }
  .BackPanel {
    justify-content: flex-start;
    margin-bottom: 0px;
  }
  .FiltersBlock {
    display: flex;
    position: fixed;
    width: 100%;
    height: 95%;
    left: 0;
    top: 50px;
    flex-direction: column;
    background: #ffffff;
    z-index: 2000;
    box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.04);
    border-radius: 16px;
    padding: 20px 12px 20px 12px;
  }
  .FiltersBlock .FiltersPanel {
    display: flex;
  }
  .SpaceBetween {
    overflow-y: auto;
  }
  .Filters {
    overflow-y: auto;
    height: 100%;
  }
  .FiltersBlock .OptionSelect {
    width: 100%;
  }
  .FiltersBlock .OptionBlock {
    width: 100%;
  }
  .RightBlock {
    width: 100%;
  }
  .TitlePanel {
    margin-bottom: 0px;
    padding-right: 16px;
    justify-content: space-between;
  }
  .FilterOpen {
    display: flex !important;
  }
  .TitlePanel button {
    all: initial;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background: none;
  }
  .TitlePanel button:hover {
    box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.1),
      0px 4px 4px -4px rgba(12, 12, 13, 0.05);
    transition: 0.3s;
  }
  .TitlePanel button:active {
    background: none !important;
    opacity: 0.4;
    transition: 0.3s;
  }
  .SearchBar {
    display: none;
  }
  .Questionnaires {
    padding: 24px 24px 24px 24px;
  }
  .MainInfo {
    flex-direction: row;
    margin-bottom: 0px;
    gap: 0px;
  }
  .TitleQuest {
    width: 50%;
  }
  .Price h2 {
    margin-left: auto;
  }
  .CheckMarkText {
    justify-content: flex-end;
    margin-left: auto;
  }
  @keyframes slideFromBottom {
    from {
      opacity: 0;
      transform: translateY(700px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes slideToBottom {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(700px);
    }
  }
  .slideBottom-enter-active {
    animation: slideFromBottom 0.8s ease-out;
  }
  .slideBottom-leave-active {
    animation: slideToBottom 0.8s ease-out;
  }
}
@media (max-width: 580px) {
  .MainInfo {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px;
  }
  .TitleQuest {
    width: 100%;
  }
  .Price h2 {
    margin-left: 0;
  }
  .CheckMarkText {
    justify-content: flex-start;
    margin-left: 0;
  }
  .QuestButtonsContainer {
    width: 100%;
    flex-direction: column;
  }
  .QuestButton {
    width: 100%;
  }
}
@media (max-width: 370px) {
  .container {
    padding-left: 10px;
    padding-right: 0px;
  }
  .TitlePanel {
    white-space: nowrap;
    padding-right: 0px;
  }
  .ShortInfo {
    gap: 8px;
  }
}
</style>
